import { Box, Paper, Stack, Tab, Tabs, Typography } from '@mui/material';

import { useState } from 'react';

import MixPreparedReport from './MixPreparedReport';
import MixMaterialFrequencyReport from './MixMaterialFrequencyReport';
import MixUnusedPickingStockReport from './MixUnusedPickingStockReport';
import MoveDownOutlinedIcon from '@mui/icons-material/MoveDownOutlined';
import MixConsolidationReport from './MixConsolidationReport';
import CompressOutlinedIcon from '@mui/icons-material/CompressOutlined';
const REPORT_TABS = {
  PREPARED_HISTORY: 'PREPARED_HISTORY',
  MATERIAL_FREQUENCY: 'MATERIAL_FREQUENCY',
  UNUSED_PICKING_STOCK: 'UNUSED_PICKING_STOCK',
  CONSOLIDATION: 'CONSOLIDATION',
};

export default function MixReports({ refreshKey = 0 }) {
  const [activeReport, setActiveReport] = useState(
    REPORT_TABS.PREPARED_HISTORY,
  );

  const handleReportChange = (_event, newValue) => {
    setActiveReport(newValue);
  };

  return (
    <Stack spacing={3}>
      <Box>
        <Typography variant="h5" fontWeight={700}>
          Raporty miksów
        </Typography>

        <Typography variant="body2" color="text.secondary">
          Historia wykonanych przygotowań oraz analiza częstotliwości
          występowania materiałów w pozycjach miksowych.
        </Typography>
      </Box>

      <Paper variant="outlined">
        <Tabs
          value={activeReport}
          onChange={handleReportChange}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab
            value={REPORT_TABS.PREPARED_HISTORY}
            label="Historia przygotowanych miksów"
          />

          <Tab
            value={REPORT_TABS.MATERIAL_FREQUENCY}
            label="Częstotliwość materiałów"
          />
          <Tab
            value={REPORT_TABS.UNUSED_PICKING_STOCK}
            icon={<MoveDownOutlinedIcon />}
            iconPosition="start"
            label="Nieużywany zapas 0D20"
          />
          <Tab
            value={REPORT_TABS.CONSOLIDATION}
            icon={<CompressOutlinedIcon />}
            iconPosition="start"
            label="Konsolidacja 0D20"
          />
        </Tabs>
      </Paper>

      {activeReport === REPORT_TABS.PREPARED_HISTORY && (
        <MixPreparedReport refreshKey={refreshKey} />
      )}

      {activeReport === REPORT_TABS.MATERIAL_FREQUENCY && (
        <MixMaterialFrequencyReport refreshKey={refreshKey} />
      )}
      {activeReport === REPORT_TABS.UNUSED_PICKING_STOCK && (
        <MixUnusedPickingStockReport />
      )}
      {activeReport === REPORT_TABS.CONSOLIDATION && <MixConsolidationReport />}
    </Stack>
  );
}
